import type { TOptions } from 'i18next';

import type { Translate, TranslationKey } from './translation';

export const applyOverwrites = (translate: Translate) => {
    return (key: TranslationKey, options?: TOptions) => {
        const overwrites = {
            jobCluster: translate('overwrites.jobCluster.one', options),
            jobClusters: translate('overwrites.jobCluster.many', options),
            jobFamilies: translate('overwrites.jobFamily.many', options),
            jobFamily: translate('overwrites.jobFamily.one', options),
            jobLevel: translate('overwrites.jobLevel.one', options),
            jobLevels: translate('overwrites.jobLevel.many', options),
            jobRole: translate('overwrites.jobRole.one', options),
            jobRoles: translate('overwrites.jobRole.many', options),
        };

        return translate(key, { ...overwrites, ...options });
    };
};
